import type { ReactNode } from 'react';

interface BadgeProps {
  label: string;
  /** A CSS color token, e.g. var(--color-success). */
  color: string;
  /** Optional leading glyph (a 14px lucide icon). Pairs color with a shape so
   *  status is never conveyed by color alone (a11y — instructions/04_UI_UX.md). */
  icon?: ReactNode;
}

/** A small colored status pill, optionally with a leading glyph. */
export function Badge({ label, color, icon }: BadgeProps): JSX.Element {
  return (
    <span
      className="badge"
      style={{
        color,
        background: `color-mix(in srgb, ${color} 14%, transparent)`,
      }}
    >
      {icon != null ? (
        <span className="badge__icon" aria-hidden="true">
          {icon}
        </span>
      ) : null}
      {label}
    </span>
  );
}
